import appRoutePlanning from "../../views/appRoutes/planning.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "routes/generate";
  const params = ["page", "limit"];

  $stateProvider.state("routeplanning", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appRoutePlanning,
      },
    },
    reloadOnSearch: false,
    data: { title: "Route Generation" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/routePlanning/routePlanning.urls.js